export class RcsLogin{
  public uid: string;
  public username: string;
  public passwort: string;

  constructor(uid, username, passwort){
    this.uid = uid;
    this.username = username
    this.passwort = passwort;
  }
}



// WEBPACK FOOTER //
// ./src/assets/shared/rcs-login.class.ts